import { workShiftTimeSlotSelector } from "../../store/workShiftTimeSlotSlice";
import { useAppSelector } from "../../framework/customStore";

export const useSelectWorkShiftTimeSlotById = (id: string) => {
    const state = useAppSelector((state) => state.workShiftTimeSlot);
    return workShiftTimeSlotSelector.selectById(state, id);
};
